// Resolves the Upcoming lane destination across Event Center and Video Center settings.
export const resolveUpcomingEventsMoreLink = ({
	eventCenterBaseUrl,
	videoCenterBaseUrl,
	eventCenterEnabled,
	eventCenterShowAllEvents,
	videoCenterEnabled,
	videoCenterLiveUpcomingEnabled,
}) => {
	if (eventCenterEnabled && eventCenterBaseUrl) {
		return eventCenterShowAllEvents ? `${eventCenterBaseUrl}?view=upcoming` : eventCenterBaseUrl;
	}

	if (videoCenterEnabled && videoCenterLiveUpcomingEnabled && videoCenterBaseUrl) {
		return `${videoCenterBaseUrl}?view=live-and-upcoming`;
	}

	return null;
};

// Resolves the Past Events lane destination with precise replay links preferred when available.
export const resolveReplayEventsMoreLink = ({
	eventCenterBaseUrl,
	videoCenterBaseUrl,
	eventCenterEnabled,
	eventCenterShowAllEvents,
	videoCenterEnabled,
}) => {
	if (eventCenterEnabled && eventCenterShowAllEvents && eventCenterBaseUrl) {
		return `${eventCenterBaseUrl}?view=replays`;
	}

	if (videoCenterEnabled && videoCenterBaseUrl) {
		return videoCenterBaseUrl;
	}

	if (eventCenterEnabled && eventCenterBaseUrl) {
		return eventCenterBaseUrl;
	}

	return null;
};
